export const DETECTION_CHAINS_LIST_ID = "detectionChainsList";
export const DETECTION_CHAINS_TITLE = "Detection Chains";
export const DETECTION_CHAINS_MANAGEMENT_FEATURE_FLAG = "detection_chains_management";
export const ATTRIBUTES = [
  { id: "name", title: "Name", type: "STRING", sortable: true },
  { id: "description", title: "Description", type: "STRING", sortable: false },
  { id: "threat_actor", title: "Threat Actor", type: "STRING", sortable: true },
  // Sorting on these is not supported by the backend (DBDetectionChainService only sorts name/
  // description/threat_actor), so they stay sortable: false.
  { id: "targeted_technologies", title: "Targeted Technologies", type: "STRING", sortable: false },
  { id: "industries", title: "Industries", type: "STRING", sortable: false },
  { id: "stream_categories", title: "Stream Categories", type: "STRING", sortable: false },
  { id: "definitions_count", title: "Event Definitions", type: "STRING", sortable: false },
  { id: "source", title: "Source", type: "STRING", sortable: false },
  { id: "created_at", title: "Source Created Date", type: "STRING", sortable: false },
  { id: "reference_url", title: "Reference URL", type: "STRING", sortable: false }
];
export const listElements = {
  defaultLayout: {
    entityTableId: DETECTION_CHAINS_LIST_ID,
    defaultPageSize: 15,
    defaultSort: { attributeId: "name", direction: "asc" },
    // Description, Industries, Stream Categories, Source, Source Created Date and Reference URL are
    // available but hidden by default; users can enable them via the column selector.
    defaultDisplayedAttributes: ["name", "threat_actor", "targeted_technologies", "definitions_count"],
    defaultColumnOrder: [
      "name",
      "description",
      "threat_actor",
      "targeted_technologies",
      "industries",
      "stream_categories",
      "definitions_count",
      "source",
      "created_at",
      "reference_url"
    ]
  }
};
